module.exports = __webpack_public_path__ + "images/category_lp/common/icon-step3_40ed7588dc1d2cd5fce07eddb9e348f3.png";